// eslint-disable-next-line import/no-cycle
import request from '@/utils/request'
// import axios from 'axios'
/*  顶部tbas数据

*/
export function TabsList() {
  return request({
    url: '/admin/v1/vehicle/contract/state/summary',
    method: 'post',
  })
}

// **个人租凭订单管理 顶部接口*//
export function TabListSeven(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/summary',
    method: 'post',
    data,
  })
}

/* 采销合同列表页 ----> 表格数据
    {
      "pageNum": 1, // 页数
      "pageSize": 10, // 每页条数
      "carId": 111111, // 车辆ID
      "plateNo":"xxx", // 车牌号
      "customerName":"xxx", // 客户名称
      "startEffectDate":"yyyy-MM-dd", // 合同开始日期起始日期
      "endEffectDate":"yyyy-MM-dd", // 合同开始日期结束日期
      "startEndDate":"yyyy-MM-dd", // 合同结束日期起始日期
      "endEndDate":"yyyy-MM-dd" // 合同结束日期结束日期
    }
*/
export function PurchaseAndSale(data) {
  return request({
    url: '/admin/v1/vehicle/contract/list',
    method: 'post',
    data,
  })
}

export function getLastOrder(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/getLastOrder',
    method: 'post',
    data,
  })
}

// 个人租赁订单
export function PurchaseAndSeven(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/list',
    method: 'post',
    data,
  })
}

// 获取脱敏个人租赁订单
export function getPersonalOrders(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/list/sensitive',
    method: 'post',
    data,
  })
}

/*  采销合同详情页

    {
      "contractId": 111 // 合同编号
    }
*/
export function Details(data) {
  return request({
    url: '/admin/v1/vehicle/contract/detail',
    method: 'post',
    data,
  })
}
/*  采销合同编辑页

    {
     "id": 1111111, // 合同ID，必传
    "state": 1, // 操作 1编辑/2签署，必传
    "name": "xxx", // 合同名称，必传
    "bizContractNo":"xxx", // 业务合同编号
    "templateId": 11111, // 合同模版ID
    "attachment": "xxx", // 附件
    "remarks": "xxx" // 备注，必传
    }
*/
export function getEdit(data) {
  return request({
    url: '/admin/v1/vehicle/contract/edit',
    method: 'post',
    data,
  })
}

/*  采销合同签署页支付表格

    {
         "contractId": 111 // 合同编号，必传
    }
*/
export function getPayPlanList(data) {
  return request({
    url: '/admin/v1/vehicle/contract/detailPayPlanList',
    method: 'post',
    data,
  })
}

/*  采销合同签署页关闭支付计划接口

    {
        "payPlanId": 1111111, // 支付计划ID，必传
        "contractId": 1 // 合同id，必传
    }
*/
export function getClosePayPlan(data) {
  return request({
    url: '/admin/v1/vehicle/contract/closePayPlan',
    method: 'post',
    data,
  })
}

/*  采销合同采销页

    {
     "id": 1111111, // 合同ID，必传
    "name": "xxx", // 合同名称，必传
    "bizContractNo":"xxx", // 业务合同编号
    "templateId": 11111, // 合同模版ID
    "attachment": "xxx", // 附件
    "remarks": "xxx" // 备注，必传
    }
*/
export function getSign(data = {}) {
  return request({
    url: '/admin/v1/vehicle/contract/sign',
    method: 'post',
    data,
  })
}

/*  采销合同新增页——车辆ID模糊搜索接口

*/
export function FuzzySearch(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/data',
    method: 'post',
    data,
  })
}

/*    采销合同新增页——承租方姓名模糊搜索接口

    {
       "customerId": 1111111 // 客户ID，必传
    }
*/
export function getCustomerId(data = {}) {
  return request({
    url: '/admin/v1/vehicle/contract/checkCustomerContract',
    method: 'post',
    data,
  })
}

/*
  采销合同新增页——保存
  {
  "carId": 111, // 车辆ID
  "signDate": "yyyy-MM-dd", // 签署日期
  "effectDate": "yyyy-MM-dd", // 合同开始时间
  "endDate": "yyyy-MM-dd", // 合同结束时间
  "customerId": 1111, // 承租方ID
  "customerType": 1, // 承租方类型 1个人/2企业
  "customerName": "xxx", // 承租方名称
  "contactTel": "18888888888", // 联系方式
  "payForm": 1, // 支付形式   1一次性付租金/2分期付租金
  "totalRent": "10000", // 租金总金额
  "deposit": "1000", // 一次性收取押金
  "manageFee": "1000", // 一次性收取管理费
  "serviceFee": "1000", // 一次性收取服务费
  "rentPerPeriod": "1000", // 每期租金
  "payType": 1, // 支付类型  1月付预付/2月付后付
  "billingDate": "10", // 款项生成日
  "payPlans": [ // 支付计划
    {
      "payContent": 1, // 支付内容 1租金/2押金/3管理费/4服务费/5维保费用/6出险费用/7违章代办/8油费/9违约金/10车损/11免佣/100其他
      "dueDate": "yyyy-MM-dd", // 应收日期
      "payCycle": "2021/11/01-2021/11-30", // 款项周期
      "cycleDays": 30, // 周期天数
      "dueAmount": "1000", // 应收金额
      "remarks": "xxx", // 备注
    }
  ]
}
*/

// 新增关联合同
export function getRelationContractAdd(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/addRelation',
    method: 'post',
    data,
  })
}

/*
      结算信息提交接口
    {
      "contractId": 111, // 合同ID
      "state": 3, // 操作 3完成/4作废/5解约
      "penaltyAmount": "1000", // 违约金金额
      "damageAmount": "1000", // 车损金额
      "handleViolationAmount": "1000", // 代处理违章金额
      "otherAmount": "1000", // 其他金额
      "otherAmountDescribe": "xxx", // 其他金额说明
      "refundableDepositAmount": "1000", // 应退押金金额
      "refundableDepositDate": "yyyy-MM-dd", // 应退押金时间
    }
*/

export function getSettlementAdd(data) {
  return request({
    url: '/admin/v1/vehicle/contract/settlement/add',
    method: 'post',
    data,
  })
}

export function getTabCount(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/summary',
    method: 'post',
    data,
  })
}
export function getPurchaseList(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/list',
    method: 'post',
    data,
  })
}
// 获取采购订单详情
export function getPurchaseDetail(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/detail',
    method: 'post',
    data,
  })
}
// 企业租赁订单详情
export function getLeaseDetail(data) {
  return request({
    url: '/admin/v1/vehicle/lease/order/detail',
    method: 'post',
    data,
  })
}
// 采购子订单列表
export function getPurchaseCarList(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/car/list',
    method: 'post',
    data,
  })
}
// 废弃
export function getLeaseCarList(data) {
  return request({
    url: '/admin/v1/vehicle/lease/order/car/list',
    method: 'post',
    data,
  })
}
export function getReturnCarList(data) {
  return request({
    url: '/admin/v1/vehicle/order/returnCar/list',
    method: 'post',
    data,
  })
}
export function getPurchaseCarBackList(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/return/record/list',
    method: 'post',
    data,
  })
}
// 废弃
export function getLeaseCarBackList(data) {
  return request({
    url: '/admin/v1/vehicle/lease/order/return/record/list',
    method: 'post',
    data,
  })
}
export function getPurchasePayDetail(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/pay/info/detail',
    method: 'post',
    data,
  })
}
// 废弃
export function getLeasePayDetail(data) {
  return request({
    url: '/admin/v1/vehicle/lease/order/pay/info/detail',
    method: 'post',
    data,
  })
}
export function getPurchasePayPlanList(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/pay/plan/list',
    method: 'post',
    data,
  })
}
export function getLeasePayPlanList(data) {
  return request({
    url: '/admin/v1/vehicle/lease/order/pay/plan/list',
    method: 'post',
    data,
  })
}
export function getPurchaseSettlementDetail(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/settlement/detail',
    method: 'post',
    data,
  })
}
// 废弃
export function getLeaseSettlementDetail(data) {
  return request({
    url: '/admin/v1/vehicle/lease/order/settlement/detail',
    method: 'post',
    data,
  })
}
export function doPurchaseOrderConfirm(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/confirm',
    method: 'post',
    data,
  })
}
export function doLeaseOrderConfirm(data) {
  return request({
    url: '/admin/v1/vehicle/lease/order/confirm',
    method: 'post',
    data,
  })
}
// 新增采购订单
export function doPurchaseOrder(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/add',
    method: 'post',
    data,
  })
}
// 采销订单变更
export function purchaseReturnOrderAdd(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/return/record/add',
    method: 'post',
    data,
  })
}
// 租赁订单变更
export function leaseReturnOrderAdd(data) {
  return request({
    url: '/admin/v1/vehicle/lease/order/return/record/add',
    method: 'post',
    data,
  })
}

export function doPurchaseOrderClose(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/close',
    method: 'post',
    data,
  })
}
// 获取关联合同记录列表
export function getContractList(data) {
  return request({
    url: '/admin/v1/vehicle/contract/relation/record/list',
    method: 'post',
    data,
  })
}

export function doLeaseOrderClose(data) {
  return request({
    url: '/admin/v1/vehicle/lease/order/close',
    method: 'post',
    data,
  })
}
// 关联合同统计查询
export function getRelationTypeList(data) {
  return request({
    url: '/admin/v1/vehicle/contract/relation/record/summary',
    method: 'post',
    data,
  })
}

export function getOrderPaymentList(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/payment/list',
    method: 'post',
    data,
  })
}
// 废弃
export function getLeasePaymentList(data) {
  return request({
    url: '/admin/v1/vehicle/lease/order/payment/list',
    method: 'post',
    data,
  })
}
export function getOrderReceiptList(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/receipt/list',
    method: 'post',
    data,
  })
}
// 废弃
export function getLeaseReceiptList(data) {
  return request({
    url: '/admin/v1/vehicle/lease/order/receipt/list',
    method: 'post',
    data,
  })
}
export function doPurchaseOrderEdit(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/edit',
    method: 'post',
    data,
  })
}
// 应收列表查询
export function getAccountsReceivable(data) {
  return request({
    url: '/admin/v1/vehicle/contract/receivable/list',
    method: 'post',
    data,
  })
}
export function doLeaseOrderEdit(data) {
  return request({
    url: '/admin/v1/vehicle/lease/order/edit',
    method: 'post',
    data,
  })
}
export function doPurchaseOrderAdd(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/addAndReturn',
    method: 'post',
    data,
  })
}
/* 采购订单批量导入车辆 */
export function importCarExcel(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/car/import',
    method: 'POST',
    data,
  })
}

// 企业租赁订单信息列表
export function getLeaseOrderList(data) {
  return request({
    url: '/admin/v1/vehicle/lease/order/list',
    method: 'POST',
    data,
  })
}

// 企业租赁订单统计
export function getLeaseOrderSummary(data) {
  return request({
    url: '/admin/v1/vehicle/lease/order/summary',
    method: 'POST',
    data,
  })
}

// 企业租赁订单批量添加车辆
export function leaseOrderCarImport(data) {
  return request({
    url: '/admin/v1/vehicle/lease/order/car/import',
    method: 'POST',
    data,
  })
}

// 新增企业租赁订单
export function LeaseOrderAdd(data) {
  return request({
    url: '/admin/v1/vehicle/lease/order/addAndReturn',
    method: 'POST',
    data,
  })
}

export function SureGiveup(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/cancelReturnCar',
    method: 'POST',
    data,
  })
}

// 获取租赁方案列表
export function getLeasingSchemeConfigList(data) {
  return request({
    url: '/admin/v1/vehicle/rent/plan/list',
    method: 'POST',
    data,
  })
}

// 获取租赁方案列表-2
export function leasSchemeConfig(data) {
  return request({
    url: '/admin/v1/vehicle/rent/plan/list',
    method: 'POST',
    data,
  })
}

// 查询订单配置信息
export function getRentOrderConfig({ orderId }) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/rent/order/config',
    method: 'POST',
    data: {
      orderId,
    },
  })
}

// 个人订单返回上一步
export function checkOrderBack({ orderId }) {
  return request({
    url: '/admin/v1/vehicle/rent/order/lastStep',
    method: 'POST',
    data: {
      orderId,
    },
  })
}

// 更新租赁方案状态
export function updateLeasingSchemeConfig(data) {
  return request({
    url: '/admin/v1/vehicle/rent/plan/updateState',
    method: 'POST',
    data,
  })
}

// 新增租赁方案
export function addLeasingSchemeConfig(data) {
  return request({
    url: '/admin/v1/vehicle/rent/plan/add',
    method: 'POST',
    data,
  })
}

// 编辑租赁方案
export function editLeasingSchemeConfig(data) {
  return request({
    url: '/admin/v1/vehicle/rent/plan/update',
    method: 'POST',
    data,
  })
}

// 获取租赁方案上下架列表
export function getLeasingSchemeConfigRecordList(data) {
  return request({
    url: '/admin/v1/vehicle/rent/plan/record/list',
    method: 'POST',
    data,
  })
}

// 获取租赁方案详情
export function getLeasingSchemeConfigDetail(data) {
  return request({
    url: '/admin/v1/vehicle/rent/plan/detail',
    method: 'POST',
    data,
  })
}

// 获取租赁方案上下架详情
export function getLeasingSchemeConfigRecordDetail(data) {
  return request({
    url: '/admin/v1/vehicle/rent/plan/record/detail',
    method: 'POST',
    data,
  })
}

/// 合同签署记录 (e签宝线上合同签署记录)

export function contractSigning(data) {
  return request({
    url: '/admin/v1/vehicle/contract2/record/list',
    method: 'POST',
    data,
  })
}

// 查看/下载合同
export function contractDownload(data) {
  return request({
    url: '/admin/v1/vehicle/contract2/download',
    method: 'POST',
    data,
  })
}

// 发起退车
export function initiateVehicle(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/close',
    method: 'POST',
    data,
  })
}

// 租赁合同里的订单详情
export function leaseContractOrderDetail(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/detail',
    method: 'POST',
    data,
  })
}

// 租赁合同里的确认订单
export function leaseContractOrderConfirm(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/confirm',
    method: 'POST',
    data,
    headers: {
      _che_error_code: [22029],
    },
  })
}
// 个人租赁保存当前核算方案
export function addSettlement(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/addSettlement',
    method: 'POST',
    data,
  })
}
// 个人租赁订单确认并提交财务核算
export function confirmSettlement(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/confirmSettlement',
    method: 'POST',
    data,
  })
}

// 租赁订单发起合同签约
export function leaseOrderStartSign(data) {
  return request({
    url: '/admin/v1/vehicle/contract/record/startSign',
    method: 'POST',
    data,
    headers: {
      _che_error_code: [22029],
    },
  })
}

// 租赁订单作废合同签约
export function leaseOrderInvalidSign(data) {
  return request({
    url: '/admin/v1/vehicle/contract/record/invalid',
    method: 'POST',
    data,
  })
}

// 租赁订单撤销合同签约
export function leaseOrderCancelSign(data) {
  return request({
    url: '/admin/v1/vehicle/contract/record/cancel',
    method: 'POST',
    data,
  })
}

// 开通租金钱包代扣
export function walletWithholdOpen(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/walletWithhold/open',
    method: 'POST',
    data,
  })
}

// 开启网约钱包线上代扣
export function openWalletWithhold(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/walletWithhold/open',
    method: 'POST',
    data,
  })
}

// 获取付款方式
export function getPaymentMethods(data) {
  return request({
    url: '/admin/v1/vehicle/state/enum',
    method: 'post',
    data,
  })
}
// 获取应收单详情
export function getDetailReceivable(data) {
  return request({
    url: '/admin/v1/vehicle/orderAccrued/plan/detailReceivable',
    method: 'POST',
    data,
  })
}
// 开启支付宝线上代扣
export function openAlipayWithhold(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/alipayWithhold/open',
    method: 'POST',
    data,
  })
}

// 订单详情-支付计划
export function getDetailAccruedInfo(data = {}) {
  return request({
    url: '/admin/v1/vehicle/orderAccrued/plan/detailAccruedInfo',
    method: 'POST',
    data,
  })
}

// 解约网约钱包支付
export function breakWalletWithhold(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/walletWithhold/break',
    method: 'POST',
    data,
  })
}

// 企业租赁订单关闭
export function closeEnterpriseOrder(data = {}) {
  return request({
    url: '/admin/v1/vehicle/lease/order/close',
    method: 'POST',
    data,
  })
}

// 撤销网约钱包支付通知
export function cancelWalletWithhold(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/walletWithhold/cancel',
    method: 'POST',
    data,
  })
}

// 根据退车交接时间 计算 到退车交接完成时间的应收金额 和 剩余租期的应收金额
export function calculateReceivableAmount(data = {}) {
  return request({
    url: '/admin/v1/vehicle/order/returnCar/calculateReceivableAmount',
    method: 'POST',
    data,
  })
}
// 解约支付宝支付
export function terminateAlipayWithhold(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/alipayWithhold/terminate',
    method: 'POST',
    data,
  })
}
// 支付宝支付网约钱包支付详情
export function getWithholdApprovalForm(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/withhold/getApprovalForm',
    method: 'POST',
    data,
  })
}
// 撤回解约支付宝支付
export function revokeTerminateAlipayWithhold(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/alipayWithhold/terminate/revoke',
    method: 'POST',
    data,
  })
}
// 撤回解约网约钱包支付
export function revokeTerminateWalletWithhold(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/walletWithhold/break/revoke',
    method: 'POST',
    data,
  })
}

// 代扣日志查询接口
export function withholdLogList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/withhold/log/list',
    method: 'POST',
    data,
  })
}
